import script from "./SidebarExpandable.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarExpandable.vue?vue&type=script&setup=true&lang=js"

import "./SidebarExpandable.vue?vue&type=style&index=0&id=3ab4326c&scoped=true&lang=css"
import "./SidebarExpandable.vue?vue&type=style&index=1&id=3ab4326c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab4326c"]])

export default __exports__